/**
 * Google fonts the site configuration can select through `layout.typography.fontFamily`.
 *
 * The value is the axis spec of the `css2` API and has to match what the family really
 * offers: the range syntax (`300..700`) only works on variable fonts, the others need
 * the explicit list or the request answers 400 and no font is loaded.
 */
export const GOOGLE_FONTS = {
  Barlow: 'wght@300;400;500;600;700',
};

/**
 * Builds the stylesheet URL of a whitelisted font.
 *
 * @param {string} [fontFamily] - The family name coming from the site configuration
 * @returns {string|null} The URL, or `null` when the family is not whitelisted
 */
export const buildGoogleFontHref = (fontFamily) => {
  const axisSpec = GOOGLE_FONTS[fontFamily];
  if (!axisSpec) {
    return null;
  }

  const family = `${fontFamily.replace(/ /g, '+')}:${axisSpec}`;
  return `https://fonts.googleapis.com/css2?family=${family}&display=swap`;
};
